import { render, staticRenderFns } from "./CompanyRootCauseSelector.vue?vue&type=template&id=2b721f64&scoped=true&"
import script from "./CompanyRootCauseSelector.vue?vue&type=script&lang=js&"
export * from "./CompanyRootCauseSelector.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRootCauseSelector.vue?vue&type=style&index=0&id=2b721f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b721f64",
  null
  
)

export default component.exports